import nameModelValidator from 'forms/shared/validators/models/name/name';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { IdentificationNameModel } from './types';

const identificationNameValidator: ValidateJSModel<IdentificationNameModel> = {
  Name: (value, attributes, attributeName, options) => (
    isPVQForm(options?.formType) ? {
      presence: true,
      model: { validator: pvqNameModelValidator },
    } : {
      presence: true,
      model: { validator: nameModelValidator },
    }),
};

export default identificationNameValidator;
